import { WhaleuEntry, WhaleuFeed, WhaleuStats } from '../../lib/api';
import { categoryLabel, cleanText, itemDate, safeSourceUrl, sourceLabel } from './whaleu-utils';

interface WhaleuHomeFeedProps {
  feed: WhaleuFeed;
  stats?: WhaleuStats;
  loading: boolean;
  error?: string;
  onAsk: (item: WhaleuEntry) => void;
}

const MATCH_LABELS: Record<string, string> = { college: '本院', audience: '适合你', topic: '关注主题' };

function SignalItem({ item, lead = false, onAsk }: { item: WhaleuEntry; lead?: boolean; onAsk: (item: WhaleuEntry) => void }) {
  const sourceUrl = safeSourceUrl(item.url);
  return <article className={`home-signal${lead ? ' home-signal--lead' : ''}`}>
    <div className="home-signal-meta"><span>{categoryLabel(item)}</span><time>{itemDate(item)}</time></div>
    <h3>{sourceUrl ? <a href={sourceUrl} target="_blank" rel="noreferrer noopener">{cleanText(item.title)}</a> : cleanText(item.title)}</h3>
    {lead ? <p>{cleanText(item.summary) || '查看原始来源，了解完整信息。'}</p> : null}
    <footer><span>{sourceLabel(item)}</span><div>{item.match?.slice(0, 2).map((match) => <em key={match}>{MATCH_LABELS[match] || match}</em>)}<button type="button" onClick={() => onAsk(item)}>问菜根</button></div></footer>
  </article>;
}

export function WhaleuHomeFeed({ feed, stats, loading, error, onAsk }: WhaleuHomeFeedProps) {
  const [lead, ...rest] = feed.items;
  return <section className="home-whaleu ornamental-card" aria-labelledby="whaleu-feed-title">
    <header>
      <div className="section-heading compact">
        <span className="section-glyph whaleu">信</span>
        <div><span className="section-overline">WHALEU · CAMPUS SIGNALS</span><h2 id="whaleu-feed-title">与你有关的校园信号</h2><p>{feed.personalized ? '已按你的学院与受众画像筛选。' : '从可信来源中整理最近更新。'}</p></div>
      </div>
      <div className="home-whaleu-summary"><strong>{stats?.entries?.toLocaleString('zh-CN') || '—'}</strong><small>条信库资料</small><a href="/whaleu">展开信库 ›</a></div>
    </header>
    {loading ? <div className="home-signal-loading" aria-label="正在读取校园信库"><i /><i /><i /></div> : null}
    {!loading && lead ? <div className="home-signal-layout"><SignalItem item={lead} lead onAsk={onAsk} /><div className="home-signal-list">{rest.slice(0, 4).map((item) => <SignalItem key={item.id} item={item} onAsk={onAsk} />)}</div></div> : null}
    {!loading && !lead ? <div className="whaleu-empty"><b>{error ? '信库暂时没有连上' : '暂无新的校园信息'}</b><span>{error || '进入信库主动检索，或在账户页调整订阅。'}</span></div> : null}
    <footer className="home-whaleu-foot"><span><i />{feed.backend === 'postgres' ? '共享信库实时连接' : '本机只读信库'}</span><a href="/account#whaleu-subscription">调整我的筛选范围</a></footer>
  </section>;
}
